// Основные компоненты
export { Container } from './container';
export { Footer } from './footer';
export { Header } from './header';
export { Heading } from './heading';

// Блоки
export * from './blocks';

// UI компоненты
export * from './ui';

// Типы
export * from './types';

// Иконки (реэкспорт из основной папки)
export {
	ColorLeetcodeIcon,
	ColorLinkedinIcon,
	ColorTelegramIcon,
	ColorYoutubeIcon,
} from '@/shared';
